<template>
  <button
      @click="onClick"
      :class="`btn btn-${type} btn-${size} text-${textSize} gap-2 whitespace-nowrap ${textColorClass} ${hoverClass ? 'hover:' + hoverClass : ''} font-${fontWeight} ${addClassOption}`"
      :disabled="disabled"

  >
    <MagnifyingGlassIcon v-if="icon === 'search'" class="w-5 h-5"/>
    {{ text }}
  </button>
</template>

<script setup lang="ts">
import {MagnifyingGlassIcon} from "@heroicons/vue/24/outline";
import {defineEmits} from "vue";

interface Props {
  type?: 'primary' | 'secondary' | 'outline'  | 'danger'
  size?: 'sm' | 'md' | 'lg'
  text?: string
  textSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  textColorClass?: string
  fontWeight?: 'light' | 'medium' | 'bold'
  hoverClass?: string
  addClassOption?: string
  disabled?: boolean
  icon?: undefined | 'search' | 'edit' | 'delete'
}

withDefaults(defineProps<Props>(), {
  type: 'primary',
  size: 'sm',
  text: 'Button',
  textSize: 'xs',
  textColorClass: '',
  fontWeight: 'medium',
  hoverClass: '',
  addClassOption: '',
  disabled: false,
  icon: undefined,
})

const emit = defineEmits<{
  (e: "click"): void;
}>();

const onClick = () => {
  emit("click")
}
</script>
